import { memo } from "react";

import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";
import type { TextVariant } from "@/components/atoms/types";
import { ifWeb } from "@/utils/platform";

/**
 * Props for the ListEmptyView component.
 */
interface Props {
  title: string;
  description?: string;
  isDark?: boolean;
}

/**
 * View component for empty invitations list state
 * @param root0 - Component props
 * @param root0.title - Title text to display in the empty state
 * @param root0.description - Optional description text providing additional context
 * @param root0.isDark - Whether to use dark theme colors for text
 */
const ListEmptyView = ({ title, description, isDark = false }: Props) => (
  <Stack className="h-4/5 items-center justify-center gap-3">
    <Text
      variant={ifWeb<TextVariant>("title", "display-sm")}
      className="text-center"
    >
      {title}
    </Text>
    {!!description && (
      <Text
        variant="unstyled"
        className={`text-center font-medium ${ifWeb("text-body", "text-title-sm")} ${isDark ? "text-content-subtle" : "text-content-neutral-strong"}`}
      >
        {description}
      </Text>
    )}
  </Stack>
);

ListEmptyView.displayName = "ListEmptyView";

export default memo(ListEmptyView);
